<form [formGroup]="form.formGroup">

  <div class="flex flex-col space-y-2">

    <p-toolbar>
      <ng-template #start></ng-template>
      <ng-template #end>
        <div class="flex items-center">
          <svg-icon
            src="../../assets/icons/reset-default-24x24.svg"
            class="w-[25px] h-[25px] tree-icon cursor-pointer"
            (click)="applyDefaults()"
            title="Apply Defaults">
          </svg-icon>
        </div>
      </ng-template>
    </p-toolbar>

    <div class="flex flex-col">
      <label for="brineType">Brine Type</label>
      <p-select (onChange)="checkSeaWater(true)" [disabled]="isReadOnly" [options]="brineTypes" [formControlName]="form.formControlNames.brineType"
        id="brineType" optionLabel="label" optionValue="value" appendTo="body" class="w-full">
      </p-select>
    </div>

    <div class="flex flex-col">
      <label for="nominalDensity">Nominal Density</label>
        <app-validated-number-input
          [id]="'nominalDensity'"
          [control]="nominalDensityControl"
          [value]="nominalDensityControl.value"
          [validation]="densityValidation"
          [unit]="densityUnits">
      </app-validated-number-input>
    </div>

  </div>

</form>
